import React, { PropTypes } from 'react';
import Modal from 'react-modal';
//import PDFVisualizer from '../Documents/PDFVisualizer.js';
// import {store} from 'main.js';
//import pdfobject from 'pdfobject';
import { PDFObject } from 'react-pdfobject';
import { ROOT } from '../../constants/root';
//import { PDFObject } from '../../../node_modules/react-pdfobject/lib/index';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		height: '95%', // <-- This sets the height
		width: '75%', // <-- This sets the width
		overlfow: 'scroll' // <-- This tells the modal to scrol
	}
};

Modal.setAppElement('my-react-app');

export default class DownloadContent extends React.Component {
	
	constructor() {
		super();

		this.state = {
			modalIsOpen: false,
			modalOpenedHash: null
		};
	
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal(file) {
		this.setState({modalIsOpen: true, modalOpenedHash: file.hash});
	}
	
	afterOpenModal() {
		// references are now sync'd and can be accessed.
		//this.subtitle.style.color = '#f00';
	}
	
	closeModal() {
		this.setState({modalIsOpen: false});
	}

	pdfShow(file) {
		this.openModal(file);
	}

	renderModalPDF() {
		// const token = store.getState().login.credentials.token;
		if (this.state.modalIsOpen) {
			return (<Modal
				isOpen={this.state.modalIsOpen}
				onAfterOpen={this.afterOpenModal}
				onRequestClose={this.closeModal}
				style={customStyles}>
				<PDFObject url={`${ROOT}/file/view/${this.state.modalOpenedHash}/?`} />
			</Modal>);
		}
		
	}

	renderFileName(file) {
		const fext = file.name.split('.').pop().toLowerCase();
		if (fext === "pdf") {
			return (
				<div className="col-md-10">
					<p className="hasFile" onClick={() => this.pdfShow(file)}> {file.name} </p> 
					
				</div>
			);
		} else {
			return ( <div className="col-md-10">
				<p> {file.name} </p>  
			</div>);
		}
	}

	onRemove(fileId, filename) {
		const m = `Tem certeza que deseja deletar ${filename}? Esse procedimento não pode ser desfeito!`;
		if ( !confirm(m) ) return;
		return this.props.deleteFile(fileId, this.props.onChangeFiles);
	}

	render () {
		if ( this.props.files.length === 0 ) return null;

		return (			
			// AAS arquivos anexados
			<div className="AAs"> 
				<h2>Arquivos Anexos</h2>
				<button className="btn btn-default btn-downloadaszip " 
				onClick={() => this.props.downloadFilesAsZip(this.props.docId)} >
					Baixar .zip
				</button>
				<hr />
				<br></br>
				<div className="container-fluid">
					{this.props.files.map((f, i) =>
						<div key={i} className="row file-row">
							<div className="col-md-10" style={{wordWrap: 'break-word'}}>
								{this.renderFileName(f)}
							</div>
							<div className="col-md-1">
								<button className="page-button pgonly"
										type="button"
										data-tip="Download"
										onClick={() => this.props.downloadFile(f)}>
									<i className="fas fa-download"></i>
								</button>
							</div>
						</div>
					)}
					{this.renderModalPDF()}
				</div>
			</div>			
		);
	}
}

DownloadContent.propTypes = {
	files: PropTypes.array.isRequired,
	downloadFile: PropTypes.func.isRequired,
	downloadFilesAsZip: PropTypes.func,
	onChangeFiles: PropTypes.func,
	deleteFile: PropTypes.func,
	docId: PropTypes.number
};


// WEBPACK FOOTER //
// ./src/components/Documents/DownloadContent.js